const GnbActionTypes = {
  HANDLE_MOBILE_GNB_MENU: 'HANDLE_MOBILE_GNB_MENU',
};

export default GnbActionTypes;
